import { useSelector } from 'react-redux';


export function useIsEventParticipantsLoaded(eventId) {
    return useSelector(state => state.events[eventId]?.participants.loaded);
}
